import { message } from 'antd'
import { TaskSystemApi } from '../../../../api/TaskSystem'
import TaskSystemLines from '../../../../components/Operations/TaskSystem/Lines/TaskSystemLines'
import { pick, isEmpty } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function TaskSystemLinesCont(props) {
  const { task, isUpdatable } = props

  console.log(task._key)
  const { list, fetching, fetch } = useFetchList(
    () => TaskSystemApi.getLinesByTask(task._key),
    [task._key],
    isEmpty(task._key),
  )

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, TaskSystemApi.lines.update, TaskSystemApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await TaskSystemApi.lines.create({ ...newObject, task: pick(task, '_id') })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <TaskSystemLines
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        task,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

TaskSystemLinesCont.propTypes = {}
TaskSystemLinesCont.defaultProps = {}

export default (TaskSystemLinesCont)
